import styled from "@emotion/styled/macro";

export const PeriodEditorContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
`;

export const YearSelector = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    background: white;
    border: 1px solid #DDE3EB;
    border-radius: 12px;
    padding: 0px;
    height: 40px;
`;

export const YearArrow = styled.button`
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #1A1B1D;
    padding: 8px;
    border-radius: 0;
    width: 48px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    border-right: ${props => props.isLeft ? '1px solid #DDE3EB' : 'none'};
    border-left: ${props => props.isRight ? '1px solid #DDE3EB' : 'none'};
    
    &:hover {
        background: #F1F3F5;
    }
    
    &:first-of-type {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }
    
    &:last-of-type {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }
`;

export const YearDisplay = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: #1A1B1D;
    text-align: center;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    height: 32px;
    margin: 4px;
`;

export const QuarterSelector = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    border: 1px solid #DDE3EB;
    border-radius: 12px;
    padding: 0px;
    height: 40px;
`;

export const QuarterOption = styled.button`
    background: ${props => props.isSelected ? '#F1F3F5' : 'transparent'};
    color: ${props => props.isSelected ? '#1A1B1D' : '#1A1B1D'};
    border: none;
    border-radius: 0;
    padding: 0px 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: ${props => props.isSelected ? '500' : '450'};
    transition: all 0.2s ease;
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        background: #F1F3F5;
    }
    
    &:first-of-type {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        padding-left: 4px;
    }
    
    &:last-of-type {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        padding-right: 4px;
    }
`;

export const PeriodButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 4px;
`;

export const PeriodButton = styled.button`
    padding: 0px 16px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 450;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #DDE3EB;
    flex: 1;
    max-width: 104px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    ${props => props.variant === 'primary' ? `
        background: #1A1B1D;
        color: white;
        border-color: #1A1B1D;
        
        &:hover {
            background: #000;
            border-color: #000;
        }
    ` : `
        background: white;
        color: #1A1B1D;
        border-color: #DDE3EB;
        
        &:hover {
            background: #F1F3F5;
        }
    `}
`; 